// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"4b634c9f","975":"a745420e"}[chunkId] + ".chunk.css";
};